import { useCallback, useEffect, useState } from "react";
import { Container } from "./styled";
import secureLocalStorage from "react-secure-storage";
import { faFileExcel, faMapLocation, faPrint, faUser } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "antd";

//STYLES

//APP
import { useAccess } from "../../../../../../context/useAccess";
import { gerarPdfDataUrl } from "./meta/gerarPDFCompraInsumos";
import { gerarExcelCompraInsumos } from "./meta/gerarExcelCompraInsumos";
import { estruturaCompraInsumos } from "./meta";
import { Item__Atividades, ItemPropriedades } from "../../../../../../services/atividades/GET";

//COMPONENTS
import Footer from "../../../../../../Components/Footer";
import ButtonCustom from "../../../../../../Components/ButtonCustom";
import { Switcher } from "../../../../../../Components/CustomUi/Switcher";
import { PopSelect } from "../../../../../../Components/CustomUi/PopSelect";
import Tabs from "../../../../../../Components/Tabs";
import { Warning } from "../../../../../../Components/CustomUi/warning";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { obterLogo } from "../../../../precisao/mapaFertilidadeResumido/components/tabelaMapas/components/bookFertilidadeResumidoSeparado/components/capa/meta";
import { localConfig } from "../../../../../../Configs/localConfig";


//PROPS
interface Props {
    data_propriedades: ItemPropriedades[];
    data_atividades: Item__Atividades[];
}

export const CompraInsumos: React.FC<Props> = ({ data_propriedades, data_atividades }) => {

    //CONST
    const { consultoria, nameCliente, } = useAccess();

    //STATES
    const [cod_propriedade_selecionada, setCod_propriedade_selecionada] = useState<number>(null);
    const [nome_propriedade_selecionada, setNome_propriedade_selecionada] = useState<string>('');
    const [gerar_por_propriedade, setGerar_por_propriedade] = useState<boolean>(false);
    const [tabSelecionado, setTabSelecionado] = useState<'Por cliente' | 'Por propriedade'>('Por cliente');

    // PDF Modal states
    const [modalPdfOpen, setModalPdfOpen] = useState(false);
    const [pdfDataUrl, setPdfDataUrl] = useState<string | null>(null);
    const [gerandoPdf, setGerandoPdf] = useState(false);
    const [gerandoExcel, setGerandoExcel] = useState(false);

    useEffect(() => {
        if (!gerar_por_propriedade) {
            setCod_propriedade_selecionada(null);
            setNome_propriedade_selecionada('');
        }
    }, [gerar_por_propriedade])


    const gerarPDF = useCallback(async () => {
        setGerandoPdf(true);
        try {
            const email_usuario_logado = secureLocalStorage.getItem('Itens')?.[0]?.email?.toLowerCase() || '';
            const estrutura_insumos = estruturaCompraInsumos(data_atividades, data_propriedades, cod_propriedade_selecionada, gerar_por_propriedade);
            const headerInfo = {
                logo: obterLogo() ?? consultoria?.logo_url,
                titulo: "Relatório de Insumos Totalizados",
                razaoSocial: consultoria.linha1 ?? '',
                cliente: nameCliente || '',
                autor: email_usuario_logado
            };

            const dataUrl = await gerarPdfDataUrl(estrutura_insumos, headerInfo);
            setPdfDataUrl(dataUrl);
            setModalPdfOpen(true);
        } catch (error) {
            console.error("Erro ao gerar PDF:", error);
        } finally {
            setGerandoPdf(false);
        }
    }, [data_atividades, data_propriedades, consultoria, nameCliente, cod_propriedade_selecionada, gerar_por_propriedade]);

    const gerarExcel = useCallback(async () => {
        setGerandoExcel(true);
        try {
            const email_usuario_logado = secureLocalStorage.getItem('Itens')?.[0]?.email?.toLowerCase() || '';
            const estrutura_insumos = estruturaCompraInsumos(data_atividades, data_propriedades, cod_propriedade_selecionada, gerar_por_propriedade);

            const headerInfo = {
                logo: obterLogo() ?? consultoria?.logo_url,
                titulo: "Relatório de Compra de Insumos",
                razaoSocial: consultoria.linha1 ?? '',
                cliente: nameCliente || '',
                autor: email_usuario_logado
            };

            await gerarExcelCompraInsumos(estrutura_insumos, headerInfo);
        } catch (error) {
            console.error("Erro ao gerar Excel:", error);
        } finally {
            setGerandoExcel(false);
        }
    }, [data_atividades, data_propriedades, consultoria, nameCliente, cod_propriedade_selecionada, gerar_por_propriedade]);


    useEffect(() => {
        setGerar_por_propriedade(tabSelecionado === 'Por propriedade');
    }, [tabSelecionado])


    return (
        <Container style={{ minHeight: 'calc(100vh - 130px)' }}>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 20 }}>
                <Tabs
                    label="Forma de totalizar"
                    tabs={[{ descricao: 'Por cliente', icone: faUser }, { descricao: 'Por propriedade', icone: faMapLocation }]}
                    onChange={setTabSelecionado}
                    selecionado={tabSelecionado}
                    width={356}
                />
                {gerar_por_propriedade
                    ? <>
                        <PopSelect
                            label="Gerar de apenas uma propriedade"
                            empty_placeholder="Selecione a propriedade"
                            value={nome_propriedade_selecionada}
                            onChange={setNome_propriedade_selecionada}
                            onChangeId={setCod_propriedade_selecionada}
                            items={data_propriedades}
                            descricaoItem="nome"
                            idItem="cod"
                            icon={faMapLocation}
                        />

                        {nome_propriedade_selecionada
                            ? <Warning type="info">
                                Os insumos serão agrupados pela propriedade "{nome_propriedade_selecionada}".
                            </Warning>
                            : <Warning type="info">
                                Os insumos serão agrupados por propriedade.
                            </Warning>
                        }


                    </>
                    : <>
                        <Warning type="info">
                            Os insumos serão totalizados considerando todas as propriedades do cliente.
                        </Warning>
                    </>}

            </div>

            <Footer style={{ justifyContent: 'flex-start', gap: 10, width: '100%' }}>
                <ButtonCustom
                    icon={<FontAwesomeIcon icon={faFileExcel} />}
                    onClick={gerarExcel}
                    loading={gerandoExcel}
                >
                    Gerar Excel
                </ButtonCustom>
                <ButtonCustom
                    icon={<FontAwesomeIcon icon={faPrint} />}
                    onClick={gerarPDF}
                    type="secondary"
                    loading={gerandoPdf}
                >
                    Gerar PDF
                </ButtonCustom>
            </Footer>

            <Modal
                title="Visualizar PDF do relatório"
                open={modalPdfOpen}
                onCancel={() => { setPdfDataUrl(null); setModalPdfOpen(false) }}
                footer={null}
                width="80%"
                style={{ top: 20 }}
                destroyOnClose
            >
                {pdfDataUrl ? (
                    <iframe
                        src={pdfDataUrl}
                        width="100%"
                        height="700px"
                        style={{ border: 'none' }}
                        title="PDF Viewer"
                    />
                ) : (
                    <p>Carregando PDF...</p>
                )}
            </Modal>
        </Container>
    );
};